
import { useState, useEffect } from 'react'
import { projectFirestore } from '../../firebase/config'
import RecipeList from '../../components/RecipeList'

// styles
import './xindex.css'
import './Home.css'

import { useAuthContext } from '../../hooks/useAuthContext'
// import { useCollection } from '../../hooks/useCollection'

// styles
import styles from './Home.module.css'

//components
//import TransactionForm from './TransactionForm'
//import TransactionList from './TransactionList'

export default function Home() {
  const { user } = useAuthContext()
  // const { documents, error } = useCollection(
  //   'transactions', ["uid", "==", user.uid], ['createdAt', 'desc']
  // )
  //---------------------------------------------------------
  const [data, setData] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    setIsPending(true)

    const unsub = projectFirestore.collection('recipes').orderBy('stars', 'desc').onSnapshot(snapshot => {
      if (snapshot.empty) {
        setError('No recipes to load')
        setIsPending(false)
      } else {
        let results = []
        snapshot.docs.forEach(doc => {
          // console.log(doc)
          results.push({ ...doc.data(), id: doc.id })
        })
        setData(results)
        setIsPending(false)
      }
    }, err => {
      setError(err.message)
      setIsPending(false)
    })

    return () => unsub()

  }, [])
  //================================================

  return (
    < div className="home" >

      {/* <div className={styles.container}>

    <div className={styles.sidebar}>
        <TransactionForm uid={user.uid} />
      </div>
      <div className={styles.content}>
        {error && <p>{error}</p>}
        {documents && <TransactionList transactions={documents} />}
      </div> */}

      {/* //   <div>
    //     <h1>Home</h1>
    //   </div>
    // </div> */}

      {error && <p className="error">{error}</p>}
      {isPending && <p className="loading">Loading...</p>}
      {data && <RecipeList recipes={data} />}
    </div >

  )
}
